import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "DealCircled",
  "use": "DealCircled-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"DealCircled\"><path d=\"M23.5 15.7l-7.2-7.2c-.3-.3-.7-.5-1.1-.5H9.6C8.7 8 8 8.7 8 9.6v5.6c0 .4.2.8.5 1.1l7.2 7.2c.3.3.7.5 1.1.5.4 0 .8-.2 1.1-.5l5.6-5.6c.3-.3.5-.7.5-1.1 0-.4-.2-.8-.5-1.1zM10.8 12c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2zM16 31C7.7 31 1 24.3 1 16S7.7 1 16 1s15 6.7 15 15-6.7 15-15 15zm0-28C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13S23.2 3 16 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol